import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { useCancelBroadbandPage } from "@pages/CancelBroadband/useCancelBroadbandPage";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { CancelBroadband } from "@features/CancelBroadband/CancelBroadband";
import { SectionTitle } from "@common/SectionTitle/SectionTitle";
import { ACCOUNT_DETAILS_PAGE_URL } from "@constants";
import { CancelBroadbandError } from "@features/CancelBroadband/CancelBroadbandError/CancelBroadbandError";

export const CancelBroadbandPage = () => {
    const { t } = useTranslation("cancelBroadband");
    const { getTerminationRequestState, terminationRequest, getTerminationRequest } = useCancelBroadbandPage();
    const { error, isLoading } = getTerminationRequestState;

    return (
        <>
            <SubNavigation />
            <div className="container-boxed">
                <SectionTitle backButtonUrl={ACCOUNT_DETAILS_PAGE_URL} title={t("cancelBroadband")} />
                <HandleErrorAndLoading
                    error={error}
                    errorComponent={<CancelBroadbandError />}
                    hideComponentWrapper
                    isLoading={isLoading}
                >
                    <CancelBroadband
                        getTerminationRequest={getTerminationRequest}
                        terminationRequest={terminationRequest}
                    />
                </HandleErrorAndLoading>
            </div>
        </>
    );
};
